export interface BioData {
  name: string;
  image: string;
  title: string;
  content: string;
}

export async function loadBio(memberName: string): Promise<BioData | null> {
  try {
    const response = await fetch(`/data/bios/${memberName}.md`);
    if (!response.ok) {
      throw new Error(`Failed to load bio: ${response.statusText}`);
    }
    const markdown = await response.text();
    return parseBioMarkdown(markdown);
  } catch (error) {
    console.error('Error loading bio:', error);
    return null;
  }
}

function parseBioMarkdown(markdown: string): BioData {
  const lines = markdown.split('\n');
  const bio: BioData = {
    name: '',
    image: '',
    title: '',
    content: ''
  };

  let metadataEnded = false;
  const contentLines: string[] = [];
  
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (line.startsWith('**Name:**')) {
      const nameFirstLine = line.replace('**Name:**', '').trim();
      // Check if next line exists and is not empty and not a metadata field
      if (i + 1 < lines.length && lines[i + 1].trim() !== '' && !lines[i + 1].trim().startsWith('**')) {
        bio.name = nameFirstLine + '\n' + lines[i + 1].trim();
        i++; // Skip the next line since we've already processed it
      } else {
        bio.name = nameFirstLine;
      }
    } else if (line.startsWith('**Image:**')) {
      bio.image = line.replace('**Image:**', '').trim();
    } else if (line.startsWith('**Title:**')) {
      const titleFirstLine = line.replace('**Title:**', '').trim();
      // Check if next line exists and is not empty and not a metadata field
      if (i + 1 < lines.length && lines[i + 1].trim() !== '' && !lines[i + 1].trim().startsWith('**')) {
        bio.title = titleFirstLine + '\n' + lines[i + 1].trim();
        i++; // Skip the next line since we've already processed it
      } else {
        bio.title = titleFirstLine;
      }
    } else if (!metadataEnded && line === '' && i > 3) {
      metadataEnded = true;
    } else if (metadataEnded) {
      contentLines.push(lines[i]); // Keep original line with spacing
    }
  }
  
  // Join content lines and split by double newlines to get paragraphs
  const contentText = contentLines.join('\n').trim();
  const paragraphs = contentText.split('\n\n').filter(p => p.trim() !== '');
  
  // Convert each paragraph to HTML
  const htmlParagraphs = paragraphs.map(p => `<p>${p.trim()}</p>`);
  bio.content = htmlParagraphs.join('\n');
  
  return bio;
}